import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui';

export function NotFoundPage() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center text-center animate-fade-in">
      <div className="relative mb-6">
        <div className="text-[120px] font-black leading-none tracking-tighter text-border select-none">
          404
        </div>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-5xl font-black tracking-tighter text-fg">404</span>
        </div>
      </div>
      <h1 className="text-xl font-semibold tracking-tight text-fg">Page not found</h1>
      <p className="mt-2 max-w-sm text-sm text-fg-muted">
        The page you requested doesn't exist or has been moved to a different location.
      </p>
      <Link to="/overview" className="mt-8">
        <Button>
          <ArrowLeft className="mr-1.5 h-4 w-4" aria-hidden />
          Back to overview
        </Button>
      </Link>
    </div>
  );
}
